// extracted by mini-css-extract-plugin
export default {"addResourceBtn":"ListingResources_addResourceBtn__t6yhO"};